import { render, staticRenderFns } from "./JingLuoDetailPage.vue?vue&type=template&id=699f3f5e"
import script from "./JingLuoDetailPage.vue?vue&type=script&lang=js"
export * from "./JingLuoDetailPage.vue?vue&type=script&lang=js"
import style0 from "./JingLuoDetailPage.vue?vue&type=style&index=0&id=699f3f5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports